import { PlusOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Drawer,
    Form,
    Input,
    Row,
    Select,
    Space,
    Spin
} from "antd";
import { Component } from "react";
import "../styles/general.css";

import { GET, POST } from "../constants/request-type";
import {
    country,
    create_province,
    get_all_country,
    province as provinceRoute
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Province_new extends Component {
  state = {
    visible: false,
    province: "",
    tax: 0,
    country: "",
    list: [],
    locked: false,
    load: false
  };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: country + "/" + get_all_country,
      data: null,
      token: token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      this.setState({
        load: false,
        list: decryptSingleData(response.data.country)
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const { province, country, tax } = this.state;

    const data = {
      province: province.toLowerCase(),
      setting: country,
      tax: tax
    };

   

    const request_details = {
      type: POST,
      url: service_api,
      route: provinceRoute + "/" + create_province,
      data: data,
      token: token
    };

    if (data.province.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    if (data.country === "") {
      this.setState({ load: false });
      return openNotificationWithIcon("error", "Veuillez selectionner un pays");
    }

    if (data.tax < 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "La taxe ne peut être en dessous de zéro"
      );
    }

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { province, country, tax, list, load } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          <PlusOutlined /> Ajouter une province
        </Button>
        <Drawer
          title="Ajouter un province"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="province"
                  label="province"
                  rules={[
                    {
                      required: true,
                      name: "Province"
                    }
                  ]}
                >
                  <Input
                    name="province"
                    placeholder="Province"
                    onChange={this.handleChange}
                    value={province}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="tax"
                  label="tax"
                  rules={[
                    {
                      required: true,
                      name: "Taxe"
                    }
                  ]}
                >
                  <Input
                    name="tax"
                    placeholder="Taxe"
                    onChange={this.handleChange}
                    value={tax}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="country"
                  label="Pays"
                  rules={[
                    {
                      required: true,
                      name: "Pays"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Selectionner parmis les options"
                    defaultValue={country}
                    onChange={(data) => {
                      return this.setState({ country: data });
                    }}
                  >
                    {list.map((item) => (
                      <Option key={item._id} value={item._id}>
                        <span>{item.country.country_name}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Province_new;
